import React from "react";
import SingleResult from "./SingleResult";
import MultipleResult from "./MultipleResult";
import NoResult from "./NoResult";
import ApproxResultWarning from "./ApproxResultWarning";
import SearchResultsWarning from "./SearchResultWarning";
import FactAndButtons from "./FactAndButtons";

function FillResults({ fillData, singleResult }) {
  if (fillData.matchType === "noMatch") {
    return <NoResult fillData={fillData} />;
  }
  const makeMultipleSingleResults = (fillData) => {
    
    return Object.keys(fillData).reduce((acc, cur) => {
      if (cur === "matchType") {
        return acc;
      } else {
        if(singleResult) {
          return [...acc, <SingleResult key={cur} fillData={fillData[cur]} />]
        }
        else {
          return [...acc, <MultipleResult key={cur} fillData={fillData[cur]} />]
        }
      }
    }, []);
  };

  const results = makeMultipleSingleResults(fillData);
  let warningContent = <div></div>;
  if(fillData.matchType === "approx") {
    warningContent = <ApproxResultWarning approxResults={results} />;
  }

  if(fillData.matchType === 'search') {
    warningContent = <SearchResultsWarning searchResults={results} />;
  }

  return (
    <div className="mt-5">
        {warningContent}
        {!singleResult ? <FactAndButtons /> : <div></div>}
        {results}
    </div>
  );
}

export default FillResults;
